import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HeaderComponent } from '../../../layout/header/header.component';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { FileSaverService } from '../../services/file-saver/file-saver.service';
import { RequestsService } from '../../services/requests.service';
import { NzSpinComponent } from 'ng-zorro-antd/spin';

@Component({
  selector: 'app-file-saver',
  standalone: true,
  imports: [
    HeaderComponent,
    TranslateModule,
    NzButtonComponent,
    NzIconDirective,
    NzSpinComponent
  ],
  templateUrl: './file-saver.component.html',
  styleUrl: './file-saver.component.scss'
})
export class FileSaverComponent implements OnInit {
  fileId!: number;
  private activatedRoute = inject(ActivatedRoute);
  private fileSaver = inject(FileSaverService);
  private requestService = inject(RequestsService);
  private id!: string;
  loading = false;

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((param) => {
      //TODO id
      console.log(param);
      if (param['id']) {
        this.id = param['id'];
        this.download();
      }
    });
  }

  download() {
    this.loading = true;
    this.fileSaver.getFile(this.id).subscribe(
      (res) => {
        console.log('file', res);
        this.loading = false;
        const file = this.fileSaver.base64ToBlob(
          res?.base64,
          res?.extension,
          res?.fileName
        );
        this.requestService.savePdf(file.blob, res?.fileName);
      },
      (error) => {
        this.loading = false;
      }
    );
  }
}
